import i18next from 'i18next'
import z, { ZodType } from 'zod'

export const gamAdRenderMargin: ZodType<number> = z.number().int().min(0)
export const gamAdRequestMargin: ZodType<number> = z.number().int().min(0)
export const kvTargetingAndPrebidAuction: ZodType<number> = z.number().int().min(0)
export const mobileScaling: ZodType<number> = z.number().min(0).multipleOf(0.01)

export const lazyLoadingSchema = z.object({
  gamAdRenderMargin,
  gamAdRequestMargin,
  kvTargetingAndPrebidAuction,
  lazyLoadTargetingPrebidAuctionEnabled: z.boolean(),
  mobileScaling,
})

export const validateLazyLoadingSchema = (
  {
    gamAdRenderMargin,
    gamAdRequestMargin,
    kvTargetingAndPrebidAuction,
    lazyLoadTargetingPrebidAuctionEnabled,
  }: Partial<z.infer<typeof lazyLoadingSchema>>,
  ctx: z.RefinementCtx,
): void => {
  if (gamAdRequestMargin !== undefined && kvTargetingAndPrebidAuction !== undefined) {
    if (lazyLoadTargetingPrebidAuctionEnabled && gamAdRequestMargin > kvTargetingAndPrebidAuction) {
      ctx.addIssue({
        code: 'custom',
        message: i18next.t(
          'features/domain:form.viewabilityTools.basicSettings.lazyLoadingEnabled.options.gamAdRequestMargin.dependencyError',
        ),
        path: ['gamAdRequestMargin'],
      })
    }
  }

  if (gamAdRenderMargin !== undefined && gamAdRequestMargin !== undefined) {
    if (gamAdRenderMargin > gamAdRequestMargin) {
      ctx.addIssue({
        code: 'custom',
        message: i18next.t(
          'features/domain:form.viewabilityTools.basicSettings.lazyLoadingEnabled.options.gamAdRenderMargin.dependencyError',
        ),
        path: ['gamAdRenderMargin'],
      })
    }
  }
}
